import {
  FETCHING_JURIDICTIONAL_BREAKDOWN,
  FETCH_JURISDICTIONAL_BREAKDOWN_SUCCESS,
  FETCH_JURISDICTIONAL_BREAKDOWN_FAILED,
  RESET_JURISDICTIONAL_BREAKDOWN
} from './InvoiceDetailConstants';
import axios from 'axios';

const fetchingJurisdictionalBreakdown = () => ({ type: FETCHING_JURIDICTIONAL_BREAKDOWN});
const fetchJurisdictionalBreakdownSuccess = invoiceDetail => ({ type: FETCH_JURISDICTIONAL_BREAKDOWN_SUCCESS, invoiceDetail} );
const fetchJurisdictionalBreakdownFail = error => ({ type: FETCH_JURISDICTIONAL_BREAKDOWN_FAILED, error});

const url = 'utm/v1/invoice-lines';

export const fetchInvoiceJurisdictionalBreakdown = invoiceId => dispatch => {
  dispatch(fetchingJurisdictionalBreakdown());
  axios.get(`${url}/${invoiceId}/jurisdictional-breakdown`)
    .then(response => {
      if (response.data.status === 500) {
        dispatch(fetchJurisdictionalBreakdownFail());
      }
      else {
        dispatch(fetchJurisdictionalBreakdownSuccess(response.data.data));
      }
    })
    .catch(err => {
      throw err;
    });
};

export const resetJurisdictionalBreakdown = () => ({ type: RESET_JURISDICTIONAL_BREAKDOWN });


// WEBPACK FOOTER //
// ./src/redux/invoiceDetail/InvoiceDetailActions.js